/* global axios */
import ApiClient from '../ApiClient';

class WgptBotEvalResultsAPI extends ApiClient {
  constructor(botId) {
    super(`bots/${botId}/eval_results`, { accountScoped: true, wgpt: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }
}

export default WgptBotEvalResultsAPI;
